module.exports = __webpack_public_path__ + "static/media/ms-bank.c08549d2.svg";